import {  Button, Col, Modal, Row, Tabs } from "antd"
import { useEffect, useState } from "react";
import { TabPane } from "semantic-ui-react";
import apiJurados from "../../../api/Jurados/api-jurados";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { ObjNotificaciones } from "../../../config/notificaciones";
import { Educacion } from "./Components/Educacion";
import { Experiencia } from "./Components/Experiencia";
import { Observaciones } from "./Components/Observaciones";
import { PerfilJurado } from "./Components/PerfilJurado";
import { RecoPubli } from "./Components/RecoPubli";
import { ModalLineas } from "./ModalLineas";

export const ModalVerMasJurado = ({ openModal, setOpenModal, idJurado, radicado, id_postulacion, obtenerJurados, areaPrincipal, tipoPostulacion }: any) => {

    const onCancel = () => {
        setOpenModal(false);
    }

    const [jurado, setJurado] = useState<any>({});
    // const [fotoJurado, setFotoJurado] = useState<any>()

    const [viewData, setViewData] = useState(false);
    const obtenerJuradoPorId = async () => {
        try {
            const jurado = await apiJurados.obetenerJuradoId(idJurado);
            // if (jurado.path_foto) {
            //     const fotoJurado = await apiDocumentos.consultarArchivo(jurado.path_foto);
            //     const reader = new FileReader();
            //     reader.onloadend = () => {
            //         setFotoJurado(URL.createObjectURL(fotoJurado));
            //     };
            //     reader.readAsDataURL(fotoJurado);
            // }
            setJurado(jurado)
            setViewData(true);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            obtenerJuradoPorId();
        }
        return () => {
            mounted = false;
        }
    }, [])


    const [observaciones, setObservaciones] = useState("");
    const [cumpleRequisitos, setCumpleRequisitos] = useState(false);

    const [modalConvocatorias, setModalConvocatorias] = useState(false)
    const guardar = async () => {
        try {
            let payload: any = {
                idJurado,
            }
            if (cumpleRequisitos) {
                payload.estado = 'Postulado'
            } else {
                payload.estado = 'No cumple'
            }

            await apiParticipantes.actualizarObservacion(id_postulacion, observaciones);
            await apiJurados.cambiarEstadoJurado(payload.idJurado, payload.estado);
            if(payload.estado === 'No cumple') {
                obtenerJurados(tipoPostulacion);
                return setOpenModal(false)
            }
            setModalConvocatorias(true);
            await ObjNotificaciones.MSG_SUCCESS("success", "Se ha actualizado correctamente");
        } catch (error) {
            console.log(error);
        }
    }


    function capitalize(sentence: string) {
        if (sentence) {
            let palabraMinuscula = sentence.toLowerCase();
            return palabraMinuscula[0].toUpperCase() + palabraMinuscula.slice(1);
        }
    }
    return (
        <>
            <Modal
            className="ant-modal-close-x2"
            title={
                <div className=" font-color-000000CC font-size-14px">Postulación a jurado<span className="ms-3 font-color-535353 font-size-14px font-family-Montserrat-Regular">código {radicado}</span></div>
            }
            width={1400}
            visible={openModal}
            onCancel={onCancel}
            maskStyle={{
                backgroundColor: "rgba(6, 100, 144, 0.8)",
              }}
            footer={
                <>
                    <div className="justify-content-flex-end">
                        
                            <Button className="button-gray-ghost order-0" onClick={onCancel}>
                                 Cerrar
                            </Button>
                        
                        
                           
                                <Button className="button-azul-radius order-1" onClick={guardar}>
                                    {!cumpleRequisitos ? 'Guardar y cerrar' : 'Postular jurado'}
                                </Button>
                           
                        
                    </div>
                </>
            }
        >
            <div className="container-fluid">
            <div className="row">
                <div className="col-12 col-lg-4 col-xl-2 mb-3">
                    <div className="row">
                    {/* <div className="col-12 col-md-3 col-lg-12">
                            {fotoJurado ?
                                <Avatar size={127} src={fotoJurado} /> : <Avatar size={127}  icon={<UserOutlined />} />
                            }
                        </div>*/}
                        <div className="col-12 col-md-9 col-lg-12">
                        <div className="font-size-14px font-family-Montserrat-SemiBold mt-2">{jurado.primer_nombre} {jurado.segundo_nombre}</div>
                        <div className="font-size-14px font-family-Montserrat-SemiBold">{jurado.primer_apellido} {jurado.segundo_apellido}</div>
                            <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">Tipo de documento:
                                <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                                    {jurado.tipo_identificacion}
                                </span>
                            </div>
                            <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">No. documento:
                                <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                                    {jurado.numero_documento}
                                </span>
                            </div>
                            <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">Municipio:
                                <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                                    {jurado.municipio_residencia &&
                                            capitalize(jurado.municipio_residencia)
                                        }
                                </span>
                            </div>
                            <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">Departamento:
                                <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                                    {jurado.departamento_residencia &&
                                            capitalize(jurado.departamento_residencia)
                                        }
                                </span>
                            </div>
                            <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">País:
                                <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                                    {jurado.pais_nacimiento &&
                                            capitalize(jurado.pais_nacimiento)
                                        }
                                </span>
                            </div>
                            {/*<div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">Cel:
                                <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                                    {jurado.telefono_celular}
                                </span>
                            </div>*/}
                            
                        </div>
                    </div>
                </div>
                {viewData &&
                    <div className="col-12 col-lg-8 col-xl-10">
                        <Tabs defaultActiveKey="1" >
                                <TabPane tab="Perfil de jurado" key="1">
                                    <PerfilJurado jurado={jurado} areaPrincipal={areaPrincipal} />
                                </TabPane>
                                <TabPane tab="Educación" key="2">
                                    <Educacion jurado={jurado} />
                                </TabPane>
                                <TabPane tab="Experiencia" key="3">
                                    <Experiencia jurado={jurado} />
                                </TabPane>
                                <TabPane tab="Reconocimientos y publicaciones" key="4">
                                    <RecoPubli jurado={jurado} />
                                </TabPane>
                                <TabPane tab="Observaciones del evaluador" key="5">
                                    <Observaciones
                                        observaciones={observaciones}
                                        setObservaciones={setObservaciones}
                                        cumpleRequisitos={cumpleRequisitos}
                                        setCumpleRequisitos={setCumpleRequisitos}
                                    />
                                </TabPane>
                            </Tabs>
                    </div>
                }
            </div>
            </div>
        </Modal>
		<ModalLineas
                tipoPostulacion={tipoPostulacion}
                openModal={modalConvocatorias}
                setOpenModal={setModalConvocatorias}
                id_postulacion={id_postulacion}
                setOpenModalAnterior={setOpenModal}
                obtenerJurados={obtenerJurados}
            />
        </>
    )
}
